"use client"
import { ActionIcon, Indicator, Tooltip, Group } from "@mantine/core"
import { IconMessageCircle2Filled } from "@tabler/icons-react"
import classes from "./NavbarButtonSupport.module.css"
import { useIntercom } from "@/hooks/useIntercom"
import { useTranslations } from "next-intl"

interface NavbarButtonSupportProps {
  label: string
}

export function NavbarButtonSupport({ label }: NavbarButtonSupportProps) {
  const { isReady, open, unreadCount, close, isChatOpen } = useIntercom()
  const t = useTranslations("sideNavBar.intercom")

  const tooltipLabel = isReady ? t(isChatOpen ? "states.close" : "states.open", { name: label }) : t("states.notAvailable", { name: label })

  return (
    <Group justify="center" align="center">
      <Tooltip position="right" label={tooltipLabel}>
        <Indicator disabled={!isReady || unreadCount === 0} inline size={15} label={unreadCount} color="red" offset={3}>
          <ActionIcon aria-label={label} className={classes.actionIcon} data-testid="btn-show-support-chat" variant={"transparent"} color={"gray.3"} size="lg" radius="md" disabled={!isReady} onClick={isChatOpen ? close : open}>
            <IconMessageCircle2Filled className={classes.icon} />
          </ActionIcon>
        </Indicator>
      </Tooltip>
    </Group>
  )
}
